import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import ShortcodeConnectingRequestService from '../ShortcodeConnectingRequestService';
import WithRender from './AddNewConnectivity.html';
import UserService from '../../../shared/userService/UserService';
import { Toaster } from '../../../Services/toast';
import ValidationService from '../../../Services/ValidationService';
import { ShortcodeConnectingRequestModel } from '../ShortcodeConnectingRequestModel';
import { ShortModel } from '../../Short/ShortModel';
import RatingService from '../../Rating/RatingService';
import { RatingServiceType } from '../../Rating/RatingServiceType';
import { ServiceRatingModel } from '@/components/Rating/ServiceRatingModel';
import OperatorService from '@/Services/OperatorService';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ShortcodeConnectingRequestService,
        UserService,
        RatingService,
        OperatorService
    ],
})
export default class AddNewConnectivity extends Vue {
    @Inject(ShortcodeConnectingRequestService) public shortcodeConnectingRequestService!: ShortcodeConnectingRequestService;
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(UserService) public userService!: UserService;
    @Inject(RatingService) public ratingService!: RatingService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Prop({ type: Number, required: true }) public serviceType!: number;
    @Prop({ type: Boolean, default: false })
    @Prop({ type: String, default: '' })
    public id: string | any;
    public addShortDiDialog: boolean = false;
    public User: any;
    public operatorOptions: any;
    public shortCodeTypes: any;
    public layoutSup: boolean | any;
    shortCodeModel: ShortcodeConnectingRequestModel | any = {};
    editMode: boolean = false;
    public shorts: ShortModel[] = [];
    public filterdShorts: ShortModel[] = [];
    public myShort: string = '';
    public filterShorts: ShortModel[] = [];
    public filterModel: any = {
        id: '',
        operator: '',
        name: '',
        providerId: '',
    }
    public showRatingDialog: boolean = false;
    public rating: number = 0;
    public reason: string = '';
    public submitting: boolean = false;
    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        const response = await this.shortcodeConnectingRequestService.getAll(true);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.shorts = response.result;
        this.filterdShorts = response.result;
    }
    @Watch('filterModel', { deep: true })
    public async search() {
        const response = await this.shortcodeConnectingRequestService.getAll(true);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.shorts = response.result;
    }
    public async created() {

        const response = await this.operatorService.getAll();
        if (response.isSuccess) {
            this.operatorOptions = response.result;
        }
        this.shortCodeTypes =
            [
                { "id": 1, "name": "White List" },
                { "id": 2, "name": "Black List" },
            ];
    }
    @Watch('shortCodeModel.shortCodeType', { deep: true })
    public onchangeShortCodeType() {
        this.filterShortCode();
    }

    @Watch('shortCodeModel.operatorId', { deep: true })
    public onchangeOperator() {
        this.filterShortCode();
    }
    private filterShortCode() {
        this.filterdShorts = this.shorts.filter((x) => x.shortCodeType === this.shortCodeModel.shortCodeType
            && x.operatorId === this.shortCodeModel.operatorId);
        this.myShort = '';
    }
    public get isValid(): boolean {
        return (
            this.shortCodeModel.operatorId !== 0 && this.shortCodeModel.operatorId !== null
            && this.shortCodeModel.shortCodeType !== 0 && this.shortCodeModel.shortCodeType !== null
            && this.shortCodeModel.operatorId !== undefined
            && this.shortCodeModel.shortCodeType !== undefined &&
            this.myShort !== ''
        );
    }
    public get canSelectShortCode(): boolean {
        return (
            this.shortCodeModel.operatorId !== 0 && this.shortCodeModel.operatorId !== null && this.shortCodeModel.operatorId !== undefined
            && this.shortCodeModel.shortCodeType !== 0 && this.shortCodeModel.shortCodeType !== null && this.shortCodeModel.shortCodeType !== undefined
        );
    }

    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }

    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }
    public showaddShortCodeDialog(id: string) {
        this.addShortDiDialog = true;
    }
    public hideddShortDiDialog() {
        this.addShortDiDialog = false;
    }

    get reasonRequired(): boolean {
        return this.rating > 0 && this.rating <= 2;
    }

    get canSubmit(): boolean {
        return this.rating > 0 && (!this.reasonRequired || this.reason.trim().length > 0);
    }

    public async submitRating() {
        if (!this.canSubmit) return;
        this.submitting = true;
        const model: ServiceRatingModel = {
            rating: this.rating,
            reason: this.reason,
            serviceType: RatingServiceType.ConnectivityRequest,
        };
        const response = await this.ratingService.addRating(model);
        if (response.isSuccess) {
            Toaster.success(this.$t('shared.ratingSuccess').toString());
            this.resetForm();
            this.showRatingDialog = false;
            this.$router.push({ name: 'ShortcodeConnectingRequest' });
        } else {
            Toaster.error(response.errorMessage);
        }
        this.submitting = false;
    }

    public resetForm() {
        this.rating = 0;
        this.reason = '';
    }

    async save() {
        if (!(this.shortCodeModel.operatorId !== 0 && this.shortCodeModel.operatorId !== null
            && this.shortCodeModel.shortCodeType !== 0 && this.shortCodeModel.shortCodeType !== null
            && this.shortCodeModel.operatorId !== undefined
            && this.shortCodeModel.shortCodeType !== undefined &&
            this.myShort !== '')) {
            Toaster.error(this.$t('bulkshortPage.allFiledsAreRequierd').toString());
        } else {
            const response = await this.shortcodeConnectingRequestService.post(this.myShort);
            const canRate = await this.ratingService.canRate(RatingServiceType.ConnectivityRequest);
            if (response.isSuccess) {
                Toaster.success(this.$t('bulkshortPage.addNewConnectingRequestServiceSuccessfully').toString());
                if (canRate) {
                    this.showRatingDialog = true;
                } else {
                    this.$router.push({ name: 'ShortcodeConnectingRequest' });
                }
            } else {
                Toaster.error(response.errorMessage);
            }
        }
        this.hideddShortDiDialog();
    }
}